module.exports = __webpack_public_path__ + "img/img_12 - 副本.7cc2985b.png";